import React, { useEffect, useState } from 'react'
import "./BusinessCaseCard.css";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { fetchBusinessCaseRequest } from '../../../../../store/features/actions/opportunities/businessCaseActions';
import { useParams } from "react-router-dom";
import { ValueSellingFrameworkPlaceholder } from "./ValueSellingFramworkPlaceholder";
import NoDataComp from '../../../genericComponents/uiElements/NoDataComp';
import { submitClosureRequest } from '../../../../../store/features/actions/closureAgentActions';
import { FetchSpotContactsRequest } from '../../../../../store/features/actions/targetedReachout/spotContactsActions';
import { useUser } from '../../../../../context/UserContext';
import GettingPrepared from '../../Nudges/gettingPrepared';
import CircularLoader from '../../../../HtmlElements/CircularLoader';

export default function ClosureCard({opportunityId, opportunityName}) {

    const { clientName, accountName } = useParams();
    const { user } = useUser();
    const dispatch = useDispatch();
    const { loading, successMessage, errorMessage } = useSelector(state => state.closureReducer);
    const { spotContactsData, spotContactsLoading } = useSelector(state => state?.spotContactsReducer);
    
    const [contact, setContact] = useState("");
    const [context, setContext] = useState("");
    const [contextFile, setContextFile] = useState(null);
    const [outputFile, setOutputFile] = useState(null);
    
    const [contactError, setContactError] = useState("");
    const [contextError, setContextError] = useState("");
    const [contextFileError, setContextFileError] = useState("");
    const [outputFileError, setOutputFileError] = useState("");
    const [showMoreModal, setShowMoreModal] = useState(false);
    const [contacts, setContacts] = useState([]);

    useEffect(() => {
        dispatch(FetchSpotContactsRequest({ clientName: clientName, accountName: accountName, userId: user?.id, type: 'all' }));
    }, []);

    useEffect(() => {
        // if(spotContactsData?.length){
          const contatc_result = spotContactsData.map(({ _id, name }) => ({ _id, name }));
          setContacts(contatc_result);
        // }
    }, [spotContactsData]);

    // Reset form after successful submission
    useEffect(() => {
        if (successMessage) {
            setContact("");
            setContext("");
            setContextFile(null);
            setOutputFile(null);
            setContactError("");
            setContextError("");
            setContextFileError("");
            setOutputFileError("");
        }
    }, [successMessage]);

    const allowedTypes = [
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    ];
    
    const handleFileChange = (e) => {
      const file = e.target.files[0];
      const fieldName = e.target.name; // e.g., 'proposal' or 'resume'
    
      if (!file || !allowedTypes.includes(file.type)) {
        if (fieldName === "contextFile") {
          setContextFileError("Only PDF or DOCX files are allowed.");
          setContextFile(null);
        } else if (fieldName === "outputFile") {
          setOutputFileError("Only PDF or DOCX files are allowed.");
          setOutputFile(null);
        }
      } else {
        if (fieldName === "contextFile") {
          setContextFileError("");
          setContextFile(file);
        } else if (fieldName === "outputFile") {
          setOutputFileError("");
          setOutputFile(file);
        }
      }
    };
  
    const handleSubmit = (e) => {
      e.preventDefault();
      
      let isValid = true;
  
      if (!contact) {
        setContactError("Contact is required.");
        isValid = false;
      } else {
        setContactError("");
      }
  
      if (!context) {
        setContextError("Context is required.");
        isValid = false;
      } else {
        setContextError("");
      }
  
      if (!isValid) return;
  
      const account_name = accountName+" "+opportunityName;

      const formData = {
        clientName: clientName,
        accountName: account_name,
        contact: contact,
        context: context,
        contextFile: contextFile,
        outputFile: outputFile,
        responseType: "pdf"
      };
  
      dispatch(submitClosureRequest(formData));
  
      setTimeout(function(){
        setShowMoreModal(true);
      }, successMessage);
    };
  
    return loading ? (
        <div
          className="pt-4"
          style={{
            position: 'fixed',
            top: '16px',
            right: '16px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
            gap: '12px',
            zIndex: 9999,
            pointerEvents: 'none', // so background stays clickable
          }}
        >
          {/* <h5>Processing your download request...</h5> */}
          <CircularLoader />
        </div>
      ) :  (
        <div className="agents_wrapper">

        <div className="custom_card_block mb-2">
          <div className="closure_note_wrapper">
            <div className="head_top">
              <h5 className="main_head">Closure Note</h5>
            </div>
            <div className="closure_block mt-3">
              <Form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <Form.Group className="mb-3 custom_agentform_group">
                      <Form.Label className="custom_agentform_label">Select Contact <span className='red'>*</span></Form.Label>
                      <Form.Select
                        className="custom_agentform_control"
                        value={contact}
                        name="contact"
                        // onChange={(e) => setContact(e.target.value)}
                        onChange={(e) => {
                            setContact(e.target.value);
                            setContactError("");
                        }}
                      >
                        <option value="">Select Contact</option>
                        {contacts.length && contacts.map((contact, index) => (
                        <option key={index} value={contact?.name}>
                            {contact?.name}
                        </option>
                        ))}
                        {/* <option key={0} value="Chetan Nayak">
                          Chetan Nayak
                        </option> */}
    
                      </Form.Select>
                      {contactError && <p className="text-danger">{contactError}</p>}
                    </Form.Group>
                  </div>
    
                  <div className="col-md-12">
                    <Form.Group className="mb-3 custom_agentform_group">
                      <Form.Label className="custom_agentform_label">Provide additional context <span className='red'>*</span></Form.Label>
                      <Form.Control
                        as="textarea"
                        className="contextArea"
                        placeholder="Include deal specifics and any additional context here"
                        name="context"
                        rows={3}
                        value={context}
                        // onChange={(e) => setContext(e.target.value)}
                        onChange={(e) => {
                            setContext(e.target.value);
                            setContextError("");
                        }}
                      />
                      {contextError && <p className="text-danger">{contextError}</p>}
                    </Form.Group>
                  </div>
    
                  <div className="col-md-6">
                    <Form.Group className="mb-3 custom_agentform_group">
                      <Form.Label className="custom_agentform_label d-block">Context File</Form.Label>
                      <input name="contextFile" type="file" accept=".pdf,.docx" className="custom_agentform_file" onChange={handleFileChange} />
                      {contextFileError && <p className="text-danger">{contextFileError}</p>}
                    </Form.Group>
                  </div>
    
                  <div className="col-md-6">
                    <Form.Group className="mb-3 custom_agentform_group">
                      <Form.Label className="custom_agentform_label d-block">Output File</Form.Label>
                      <input name="outputFile" type="file" accept=".pdf,.docx" className="custom_agentform_file" onChange={handleFileChange} />
                      {outputFileError && <p className="text-danger">{outputFileError}</p>}
                    </Form.Group>
                  </div>
    
                  <div className="col-md-12">
                    <div className="prev_next_block">
                      <button type="submit" className="genrate_modal_btn btn btn-primary mr-2" disabled={loading}>
                        {loading ? "Submitting..." : "Generate"}
                      </button>
                      <button 
                        type="reset" 
                        className="btn btn-secondary cancel_modal_btn mr-2" 
                        onClick={() => {
                          setContact("");
                          setContext("");
                          setContextFile(null);
                          setContactError("");
                          setContextError("");
                          setContextFileError("");
                          setOutputFile(null);
                          setOutputFileError("");
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
    
                  {errorMessage && <p className="text-danger">{errorMessage}</p>}
                </div>
              </Form>
            </div>
          </div>
        </div>
        </div>
      );
}
